import { Box, Stack, useTheme } from '@mui/material';

import classNames from 'classnames/bind';
import styles from '../../Unauthorized/ModalRegisterMasterFollower.module.scss';
import { DataOnParents, KeyDataParents } from './RegisterFollower';
import { submitRegisterFollower } from '@/controllers/gridManager/followerTransManager/followerTransManager';
import TransAuth, { AuthComponentRef } from '@/views/components/componentsUI/TransAuth';
import ButtonElement from '@/views/elements/button/ButtonElement';
import { setMsgSocketRegisterAction, setStateLoadingAction } from '@/stores/dataManager/Actions/appAction';
import { useEffect, useRef, useState } from 'react';
import ToastUtil from '@/views/components/Toast/Toast';
import { getConfigFromWindowBrowser, validateCode } from '@/utilities';
import { ENV } from '@/utilities/EWindow';
import { useGetStatusRegisterMF, useGetMsgSocketRegister } from '@/controllers/gridManager/appManager/appManager';
import TypographyElement from '@/views/elements/typography/TypographyElement';
import { useTranslation } from 'react-i18next';
import { VerifyData } from '@/controllers/gridManager/accountsManager/accountManager';
import useValidateCode from '@/componentShare/hooks/useValidateCode';
const cx = classNames.bind(styles);
const SOCKET_NOTIFICATION_TIME_WAIT = getConfigFromWindowBrowser(ENV.SOCKET_NOTIFICATION_TIME_WAIT) ?? 5

export type PropsStep = {
    close: () => void,
    back: () => void,
    next: () => void,
    handleSaveDataOnParents: (key: KeyDataParents, data: {}) => void
    dataOnParents: DataOnParents
}

const Step2 = ({ close, back, next, handleSaveDataOnParents, dataOnParents }: PropsStep) => {
    const theme = useTheme()
    const { t } = useTranslation()
    const refInterval = useRef<number | null>(null)
    const refAuth = useRef<AuthComponentRef>(null)

    const { statusRegisterMF } = useGetStatusRegisterMF()
    const { msgSocketRegister } = useGetMsgSocketRegister()

    const { Step1, dataVerify }: { Step1: any, dataVerify: VerifyData } = dataOnParents
    const { custodycd, currentAccountId } = Step1

    const [code, setCode] = useState<string>('')

    const callApiRegister = async (dataVerify: any) => {
        let flag = false
        const { isSuccess, data } = await submitRegisterFollower(currentAccountId, dataVerify)
        if (isSuccess) {
            flag = isSuccess
        } else {
            if (refInterval.current) {
                clearInterval(refInterval.current);
                refInterval.current = null
            }
            setStateLoadingAction(false)
        }

        return flag
    }

    const countdown = async (seconds: number) => {
        return new Promise((resolve, reject) => {
            let remainingTime = seconds;
            refInterval.current = setInterval(() => {
                // console.log('ha_check_msgSocketRegister_refInterval1', refInterval.current)
                remainingTime--;
                if (remainingTime < 0) {
                    if (refInterval.current) {
                        clearInterval(refInterval.current);
                        refInterval.current = null
                    }
                    setStateLoadingAction(false)
                    ToastUtil.success(t("copytrade.registerFollower.holdReq"))
                    close()
                    resolve(true);
                }
            }, 1000);

            // console.log('ha_check_msgSocketRegister_refInterval', refInterval.current)

        });
    }

    useEffect(() => {
        return () => {
            if (refInterval.current) {
                clearInterval(refInterval.current);
                refInterval.current = null
            }
        }
    }, [])

    useEffect(() => {
        console.log('ha_check_msgSocketRegister', { statusRegisterMF, msgSocketRegister, refInterval })
        if (refInterval.current) {
            clearInterval(refInterval.current);
            refInterval.current = null
        }
        if (statusRegisterMF !== null) {
            setStateLoadingAction(false)
            setMsgSocketRegisterAction(null)
            if (statusRegisterMF === 'CONFIRM') {
                next()
            } else {
                console.log('ha_check_msgSocketRegister111', { statusRegisterMF, msgSocketRegister, refInterval })
                close()
                // msgSocketRegister && ToastUtil.error(msgSocketRegister)
            }
        }
    }, [statusRegisterMF, msgSocketRegister])

    const handleNext = async () => {

        if (validateCode(code) === false) {
            ToastUtil.error(t('copytrade.common.noEmpty'))
            return
        }

        if (refAuth.current) {
            refAuth.current.processAuth()
        }
    }

    const processRegisterFollower = async (dataVerify: any) => {
        if (await callApiRegister(dataVerify)) {
            await countdown(SOCKET_NOTIFICATION_TIME_WAIT)
        }
    }


    const handleBack = () => {
        back()
    }

    const isValidCode = useValidateCode(code)

    return (
        <Box>
            <Stack
                direction={"column"}
                spacing={2}
            >
                <Stack
                    direction={"row"}
                    justifyContent={"space-between"}
                    py={2}
                    px={1}
                    borderRadius={1}
                    bgcolor={theme.palette.background.badge}
                >
                    <Box>
                        <TypographyElement FontSizeElement='14px' FontWeightElement={400} ColorElement='secondary'>
                            {t("copytrade.registerFollower.account")}
                        </TypographyElement>
                    </Box>
                    <Box>
                        {custodycd}
                    </Box>
                </Stack>

                <Box>
                    {dataVerify?.transactionId && <TransAuth
                        ref={refAuth}
                        verified={dataVerify?.verified ?? false}
                        listAuthType={dataVerify?.authtypes ?? []}
                        defaultAuthType={dataVerify?.authtype}
                        transactionId={dataVerify?.transactionId}
                        tokenId={dataVerify?.tokenid}
                        setLoadStatus={setStateLoadingAction}
                        doProcessData={{}}
                        twoFactorAuthFunc={processRegisterFollower}
                        noButton={true}
                        onAuthCodeChange={(e: string) => setCode(e)}
                    />}
                </Box>

                <Stack
                    direction={"row"}
                    spacing={2}
                    justifyContent={"center"}
                >
                    <ButtonElement customType="Secondary" className={cx("btn-register")} variant="contained"
                        onClick={() => handleBack()} >{t("copytrade.common.back")}</ButtonElement>
                    <ButtonElement customType="Primary" className={cx("btn-register")} variant="contained"
                        disabled={!isValidCode}
                        onClick={
                            () => handleNext()
                        } >{t("copytrade.common.register")}</ButtonElement>
                </Stack>
            </Stack>
        </Box>
    )
}

export default Step2